// import { createSelector } from "@reduxjs/toolkit";
import { appJotaiStore } from "../../app-jotai";
import {
  roomMetadataAtom,
  userinfoAtom,
  userMetadataAtom,
} from "../channel_state_jotai";
import { HostActions } from "./types/apis";

import type { ICurrentUserMetadata } from "./types/participant";
import type { IRoomMetadata } from "./types/room";

const updateCurrentRoomMetadata = (metadata: IRoomMetadata) => {
  // window.currentRoomMetadata = metadata;
  // log(metadata);
  appJotaiStore.set(roomMetadataAtom, metadata);
  // alert(metadata);
};
const updateCurrentUserMetadata = (metadata: ICurrentUserMetadata) => {
  // window.currentUserMetadata = metadata;
  // log(metadata);
  appJotaiStore.set(userMetadataAtom, metadata);
};
const addCurrentUser = (user: {
  name: string;
  userId: string;
  sid: string;

  isRecorder: boolean;
}) => {
  // log(user);
  appJotaiStore.set(userinfoAtom, {
    name: user.name,
    userId: user.userId,
    sid: user.sid,
    isRecorder: user.isRecorder,
    metadata: appJotaiStore.get(userMetadataAtom),
  });
  // window.currentUser = user;
};

const PARENT_APP_ORIGIN = import.meta.env.VITE_APP_ORIGIN;

const messageHandler = (event: MessageEvent) => {
  if (event.origin !== PARENT_APP_ORIGIN) {
    return;
  }

  if (event.source !== window.parent) {
    return;
  }

  if (!event.data || typeof event.data.action !== "string") {
    return;
  }

  switch (event.data.action) {
    case HostActions.user_metadata:
      if (event.data.data) {
        updateCurrentUserMetadata(event.data.data);
        console.log("IFRAME: User metadata updated:", event.data.data);
      }

      break;
    case HostActions.user_data:
      if (event.data.data) addCurrentUser(event.data.data);
      break;
    case HostActions.room_metadata:
      if (event.data.data) {
        updateCurrentRoomMetadata(event.data.data);
        console.log("IFRAME: Room metadata updated:", event.data.data);
      }
      break;
    default:
      console.warn("IFRAME: Unhandled message action:", event.data.action);
  }
};

const setupWebListener = () => {
  window.addEventListener("message", messageHandler);
  return () => {
    window.removeEventListener("message", messageHandler);
  };
};

const initConn = () => {
  try {
    /// to init with flutter in desktop
    //@ts-ignore

    if (window.flutter_inappwebview) {
      //@ts-ignore
      window.flutter_inappwebview.callHandler("Init", { key: "value" });
      console.log("IFRAME: flutter_inappwebview Init called.");
      //@ts-ignore
    } else if (window.Init) {
      /// to init with flutter in mobile
      //@ts-ignore
      window.Init.postMessage("done");
    } else {
      // This is the crucial part for web-to-web communication

      window.parent.postMessage(
        { action: "runMyFunction" },
        import.meta.env.VITE_APP_ORIGIN,
      ); // Be specific with targetOrigin
    }
  } catch (error) {
    console.error("IFRAME: Error in initConn:", error);
    setTimeout(() => {
      initConn();
    }, 300);
  }
};

export const loadListeners = () => {
  // debugger;
  window.onReceiveRoomMetadata = (data: string) => {
    try {
      const roomMetadata = JSON.parse(data) as IRoomMetadata;
      updateCurrentRoomMetadata(roomMetadata);
    } catch (error) {}
  };
  window.onUserDataReceived = (data: string) => {
    try {
      const [name, userId, sid] = JSON.parse(data);
      const isRecorder =
        (userId === "RECORDER_BOT" || userId === "RTMP_BOT") ?? false;
      addCurrentUser({
        name,
        userId,
        sid,
        isRecorder,
      });
    } catch (error) {
      console.error(error);
    }
  };
  window.onUserMetadataUpdate = (data: string) => {
    const userMetadata = JSON.parse(data) as ICurrentUserMetadata;
    // log("onUserMetadataUpdate");
    updateCurrentUserMetadata(userMetadata);
  };
  // debugger;rr
  initConn();
  setupWebListener();
};
